import classNames from "classnames";
import { FC } from "react";

interface Props {
  withBorder?: boolean;
  className?: string;
}

const ListCardSkeleton: FC<Props> = ({ withBorder, className }) => {
  return (
    <div
      className={classNames(
        " border-fds-cart hover:shadow-brand-md sm:p-4     py-2  flex  px-2.5   w-full",
        withBorder ? "rounded-8 border " : "border-y",
        className
      )}
    >
      <div className="w-2/5 h-max sm:ml-6  ml-2  bg-fds-secondary aspect-video" />
      <div className="flex flex-col w-full">
        <div className="mt-2  w-full h-6  bg-fds-secondary mb-px" />
        <div className="mt-2  w-1/2  h-6  bg-fds-secondary mb-px" />
        <div className="w-16 h-5    bg-fds-secondary my-2" />
        <div className="flex justify-between">
          <div className="flex items-center gap-x-0.5 ">
            <div className="h-5    w-5    bg-fds-secondary" />
            <div className="h-5    w-10 bg-fds-secondary" />
          </div>
          <div className="flex items-center gap-x-0.5 ">
            <div className="h-5    w-5    bg-fds-secondary" />
            <div className="h-5    w-10 bg-fds-secondary" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ListCardSkeleton;
